import React from "react";
import { Info, Calculator } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ICONS, SectionHead } from "./acqUi";

export function WhyAcquire({ items, text }) {
  return (
    <section data-testid="acq-why-section">
      <SectionHead eyebrow="The Opportunity" title="Why Acquire a Farmers Agency?" text={text} />
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {items.map((w) => {
          const Icon = ICONS[w.icon] || Info;
          return (
            <div key={w.key} className="group rounded-xl border border-slate-200 bg-white p-5 hover:border-[#006090]/40 hover:shadow-md transition-[box-shadow,border-color]" data-testid={`acq-why-${w.key}`}>
              <span className="inline-flex w-10 h-10 items-center justify-center rounded-lg bg-[#006090]/10 text-[#006090] group-hover:bg-[#006090] group-hover:text-white transition-colors"><Icon className="w-5 h-5" /></span>
              <h3 className="mt-3 font-semibold text-slate-900 text-[15px]">{w.title}</h3>
              <p className="mt-1 text-sm text-slate-600 leading-snug">{w.text}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}

const TONES = ["border-t-[#C8102E]", "border-t-[#006090]", "border-t-[#0D9488]"];

export function StartStrong({ items, note, text }) {
  return (
    <section data-testid="acq-startup-section">
      <SectionHead eyebrow="Start Strong" title="Startup Bonus Package" text={text} />
      <div className="grid md:grid-cols-3 gap-4">
        {items.map((s, i) => (
          <div key={s.key} className={`rounded-xl border border-slate-200 border-t-4 ${TONES[i % 3]} bg-white p-6`} data-testid={`acq-startup-${s.key}`}>
            <p className="font-display text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight">{s.amount}</p>
            <p className="mt-1 text-sm font-semibold uppercase tracking-wide text-[#006090]">{s.title}</p>
            <p className="mt-3 text-sm text-slate-600 leading-snug">{s.text}</p>
          </div>
        ))}
      </div>
      <p className="mt-3 text-xs text-slate-500 flex items-start gap-1.5"><Info className="w-3.5 h-3.5 mt-0.5 shrink-0" />{note}</p>
    </section>
  );
}

export function GrowthIncentives({ items, note, text, onCalc }) {
  return (
    <section data-testid="acq-incentives-section">
      <SectionHead eyebrow="Growth Incentives" title="New Agent Bonus Opportunities" text={text} />
      <div className="grid lg:grid-cols-[1fr_280px] gap-4">
        <div className="space-y-3">
          {items.map((it) => {
            const Icon = ICONS[it.icon] || Info;
            return (
              <div key={it.key} className="flex gap-4 rounded-xl border border-slate-200 bg-white p-5" data-testid={`acq-incentive-${it.key}`}>
                <span className="shrink-0 inline-flex w-11 h-11 items-center justify-center rounded-full bg-[#0B2E4F] text-white"><Icon className="w-5 h-5" /></span>
                <div><h3 className="font-semibold text-slate-900">{it.title}</h3><p className="text-sm text-slate-600 mt-1 leading-snug">{it.text}</p></div>
              </div>
            );
          })}
        </div>
        <div className="rounded-xl bg-[#0B2E4F] text-white p-6 flex flex-col justify-between" data-testid="acq-calc-teaser">
          <div>
            <Calculator className="w-8 h-8 text-sky-300" />
            <h3 className="font-display text-xl font-bold mt-3">Estimate Your Bonus Opportunity</h3>
            <p className="text-sm text-white/75 mt-2">See how the published bonus schedules could apply to an acquisition you're considering.</p>
          </div>
          <Button onClick={onCalc} className="mt-5 bg-white text-[#0B2E4F] hover:bg-sky-50" data-testid="acq-open-calculator">Open Calculator</Button>
        </div>
      </div>
      <p className="mt-3 text-xs text-slate-500 flex items-start gap-1.5"><Info className="w-3.5 h-3.5 mt-0.5 shrink-0" />{note}</p>
    </section>
  );
}
